var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('nav',{staticClass:"column-start-fullwidth align-center g-10 roboto"},[_c(_setup.CGoogleSignInButton,{attrs:{"btn-text":_vm.googleBtnText}}),_vm._v(" "),_c(_setup.CFacebookSignInButton,{attrs:{"btn-text":_vm.fbBtnText}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }